import React, { useState } from "react";

import img5 from '../assets/img/02-2025/5_0.png';
import img6 from '../assets/img/02-2025/6_0.png';
import img7 from '../assets/img/02-2025/7_0.png';
import img8 from '../assets/img/02-2025/8_0.png';

import sornUp from '../assets/img/icon/sorn-up.svg';

export default function Select4(border) {

    const [dataS, setDataS] = useState(null);
    return (
        <>
            <div className="mb-4">
                <div className="row justify-content-center text-start">
                    <div className="col-6 col-md-3 col-lg-3">
                        <button className="btn text-center" onClick={e => setDataS(1)}>
                            <img src={img5} className="w-75 px-4" />
                            <h4 className="weight-700 mt-3 h4-respon" style={{}}>Objectives</h4>
                        </button>
                    </div>
                    <div className="col-6 col-md-3 col-lg-3">
                        <button className="btn text-center" onClick={e => setDataS(2)}>
                            <img src={img6} className="w-75 px-4" />
                            <h4 className="weight-700 mt-3 h4-respon" style={{}}>Participants</h4>
                        </button>
                    </div>
                    <div className="col-6 col-md-3 col-lg-3">
                        <a href="https://drive.google.com/file/d/1I9_zrsVovq8UjaEXvDN5ibrn5OpVKTll/view?usp=drive_link" target={"_blank"} className="btn text-center">
                            <img src={img7} className="w-75 px-4" />
                            <h4 className="weight-700 mt-3 h4-respon" style={{}}>Programme</h4>
                        </a>
                    </div>
                    <div className="col-6 col-md-3 col-lg-3">
                        <a href="https://drive.google.com/file/d/1yM5U5jPSFrVdkacdAkOAsomBlmQYBmFd/view?usp=drive_link" target={"_blank"} className="btn text-center">
                            <img src={img8} className="w-75 px-4" />
                            <h4 className="weight-700 mt-3 h4-respon" style={{}}>Document</h4>
                        </a>
                    </div>
                </div>
            </div>
            <div>
                <div className="d-none d-md-block">
                    <div className="row text-start" style={{ marginBottom: "-20px" }}>
                        <div className="col-12 col-md-3 col-lg-3 text-center">
                            {dataS === 1 && <img src={sornUp} className="" style={{ width: "50px", filter: "brightness(0) saturate(100%) invert(91%) sepia(55%) saturate(6319%) hue-rotate(315deg) brightness(109%) contrast(103%)" }} />}
                        </div>
                        <div className="col-12 col-md-3 col-lg-3 text-center">
                            {dataS === 2 && <img src={sornUp} className="" style={{ width: "50px", filter: "brightness(0) saturate(100%) invert(91%) sepia(55%) saturate(6319%) hue-rotate(315deg) brightness(109%) contrast(103%)" }} />}
                        </div>
                    </div>
                </div>
                {dataS === 1 ?
                    <div className="p-4" style={{ background: "#FFDE59", borderRadius: "15px" }}>
                        <ol>
                            <li>To build a comprehensive understanding of the Sufficiency Economy Philosophy (SEP) and the Sustainable Development Goals (SDGs)</li>
                            <li>To ignite a sense of inspiration among the youth in SEAMEO Member Countries, encouraging them to champion the incorporation of SEP into sustainability efforts in their schools and communities</li>
                            <li>To nurture the skills and mindset necessary for a human-centered approach to problem- solving, using design thinking within the framework of SEP and SDGs </li>
                            <li>To facilitate valuable networking opportunities among the youth, fostering connections and collaborations </li>
                            <li>To establish a network of schools for sharing knowledge and best practices on SEP and the SDGs</li>
                        </ol>
                    </div>
                    : dataS === 2 ?

                        <div className="p-4" style={{ background: "#FFDE59", borderRadius: "15px" }}>
                            <ol>
                            <li>Participants include the 11 SEAMEO Member Countries</li>
                            <li>5 participants from each SEAMEO Member Country: 2 female students, 2 male students, and 1 teacher (male or female) </li>
                            <li>Country participants will be nominated by the Ministry/Department of Education through an official nomination form to SEAMEO SEPS. </li>
                        </ol>
                        </div>

                        : null}
            </div>

        </>
    );
}